import { render, staticRenderFns } from "./Subdivisions.vue?vue&type=template&id=f905efc8&scoped=true&"
import script from "./Subdivisions.vue?vue&type=script&lang=js&"
export * from "./Subdivisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f905efc8",
  null
  
)

export default component.exports